import React, { FC, ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Delete, Visibility, Print } from '@mui/icons-material';
import { Typography, Box, BoxProps, TableCellProps, IconButton, Avatar } from '@mui/material';

import {
  HOST_API,
  NEW_PROJECT,
  HOST_API_PROD,
  PRINT_POSSIBLE,
  PRINT_IMPOSSIBLE,
} from '../../../helpers/constants';
import {
  GetProjectsQuery,
  GetProjectsDocument,
} from '../../../graphql/query/__generated__/getProjects';
import { PatchesName } from '../../../helpers/types';
import { formatDate } from '../../../helpers/formatDate';
import { DeleteProjectModal } from './DeleteProjectModal';
import { useGetMe } from '../../../graphql/query/hooks/useGetMe';
import { TableProduct } from '../../../components/TableProduct/TableProduct';
import { useDeleteProjectMutation } from '../../../graphql/mutations/__generated__/deleteProject';

interface HeaderCell {
  title: string;
  containerProps?: TableCellProps;
}

interface BoxCell {
  val: string | ReactNode;
  containerProps?: BoxProps;
}
interface TableCellsValue {
  cellsValues: Array<BoxCell>;
}
interface Props {
  data: GetProjectsQuery | undefined;
}

export const ProjectTable: FC<Props> = ({ data }) => {
  const navigate = useNavigate();
  const [runDeleteMutation] = useDeleteProjectMutation();
  const { me } = useGetMe();

  const [isModalRemove, setIsModalRemove] = useState(false);
  const [getCode, setGetCode] = useState('');

  const [pageNumber, setPageNumber] = useState(0);

  const handleClick = () => {
    setPageNumber(pageNumber + 1);
    // const page = getNewPage(pageNumber);
  };

  const handlerDeleteButton = (code: string) => {
    setGetCode(code);
    setIsModalRemove(true);
  };

  const handlerRecordSector = (code: string) => {
    navigate(`/${PatchesName.Home}`, { state: { code: code } });
  };

  const getStatusNote = (status: string | null | undefined) => {
    if (status === 'saved') {
      return PRINT_IMPOSSIBLE;
    }
    if (status === 'done') {
      return PRINT_POSSIBLE;
    }
    return NEW_PROJECT;
  };

  const handlerDelete = async () => {
    try {
      const response = await runDeleteMutation({
        variables: {
          code: getCode || '',
        },
        refetchQueries: [
          {
            query: GetProjectsDocument,
            variables: {
              user_id: me?.id,
            },
          },
        ],
      });
      if (response) {
        setIsModalRemove(false);
      }
    } catch (error) {
      console.log('[ERROR]', error);
    }
  };
  const getHeadersTable = (): Array<HeaderCell> => {
    const style: TableCellProps = { color: '#5269A3', align: 'center' };
    return [
      { title: 'Фото', containerProps: { width: '100px', ...style } },
      {
        title: 'Дата создания',
        containerProps: { width: '80px', ...style },
      },
      {
        title: 'Дата обновления',
        containerProps: { width: '220px', ...style },
      },
      {
        title: 'Название',
        containerProps: { width: '120px', ...style },
      },
      {
        title: 'Статус',
        containerProps: { width: '120px', ...style },
      },
      {
        title: '',
        containerProps: { width: '10px', ...style },
      },
      {
        title: '',
        containerProps: { width: '10px', ...style },
      },
      {
        title: '',
        containerProps: { width: '10px', ...style },
      },
    ];
  };
  const getRowsTable = (): Array<TableCellsValue> => {
    if (data && data?.projects?.length) {
      return data?.projects?.map(item => {
        const values: Array<BoxCell> = [];
        values.push({
          val: (
            <Avatar
              alt="Remy Sharp"
              src={`${HOST_API}${item?.schema?.filename}`}
              variant="rounded"
              sx={{
                width: '100%',
                height: '100%',
                '& img': {
                  objectFit: 'contain',
                },
              }}
            />
          ),
          containerProps: {
            borderLeft: 'none',
          },
        });

        values.push({ val: formatDate(item?.created_at) });
        values.push({ val: formatDate(item?.updated_at) });
        values.push({ val: item?.name });

        values.push({
          val: (
            <Typography fontSize="12px" color={item?.status === 'done' ? '#70BF2B' : '#272727'}>
              {getStatusNote(item?.status)}
            </Typography>
          ),
          containerProps: { justifyContent: 'center' },
        });

        values.push({
          val: (
            <IconButton
              disabled={item?.status !== 'done'}
              href={`${HOST_API_PROD}${item?.code}.pdf`}
              target="_blank"
              aria-label="close"
              color="error"
              sx={{ p: 0.5, color: '#567CF0' }}
            >
              <Print />
            </IconButton>
          ),
          containerProps: { justifyContent: 'flex-end' },
        });

        values.push({
          val: (
            <IconButton
              aria-label="close"
              sx={{ p: 0.5, color: '#567CF0' }}
              onClick={() => handlerRecordSector(item?.code)}
            >
              <Visibility />
            </IconButton>
          ),
          containerProps: { borderLeft: 'none', justifyContent: 'flex-end' },
        });

        values.push({
          val: (
            <IconButton
              aria-label="close"
              sx={{ p: 0.5, color: '#567CF0' }}
              // onClick={() => handlerDeleteButton(item?.code)}
              onClick={() => handleClick()}
            >
              <Delete />
            </IconButton>
          ),
          containerProps: { borderLeft: 'none', justifyContent: 'flex-end' },
        });

        return { cellsValues: values };
      });
    }
    return [];
  };
  return (
    <Box boxSizing="border-box" width="100%">
      <TableProduct itemsRows={getRowsTable()} itemsHeader={getHeadersTable()} />
      {isModalRemove && (
        <DeleteProjectModal
          closeModal={() => setIsModalRemove(false)}
          handlerDelete={handlerDelete}
        />
      )}
    </Box>
  );
};

export default ProjectTable;
